export { default as article } from './Article'
export { default as generalPage } from './Article'
export { default as topic } from './Topic'
export { default as pageSelectStore } from './SelectStore'
export { default as splitPage } from './Split'
export { default as pageMain } from './Main'
export { default as pageRoom } from './Room'
export { default as pageBirthday } from './Birthday'
export { default as pagehotelRoom } from './HotelRoom' // TODO change to camel case, need to be changed on Contentful
